import '@fontsource/poppins';
import './ServiceModule/axiosConfig';
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import Root from './Root';
import reportWebVitals from './reportWebVitals';
import 'bootstrap/dist/css/bootstrap.min.css';
import { store } from './store';
import { Provider } from 'react-redux';
import '@fontsource/poppins/300.css';
import '@fontsource/poppins/400.css';
import '@fontsource/poppins/500.css';
import '@fontsource/poppins/700.css';
import { createTheme, CssBaseline, ThemeProvider } from '@mui/material';
import { initMonitor } from './config/monitor';
import MonitorErrorBoundary from './components/MonitorErrorBoundary';
import { registerServiceWorker } from './firebase/registerServiceWorker';

// Initialize Monitoring before rendering
initMonitor();

// Register Firebase Service Worker
registerServiceWorker();

const theme = createTheme({
  typography: {
    fontFamily: 'poppins, Arial, sans-serif',
  },
  components: {
    MuiModal: {
      defaultProps: {
        disableScrollLock: true,
      },
    },
    MuiDialog: {
      defaultProps: {
        disableScrollLock: true,
      },
    },
    MuiMenu: {
      defaultProps: {
        disableScrollLock: true,
      },
    },
    MuiPopover: {
      defaultProps: {
        disableScrollLock: true,
      },
    },
    MuiDrawer: {
      defaultProps: {
        disableScrollLock: true,
      },
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <MonitorErrorBoundary>
        <Root />
      </MonitorErrorBoundary>
    </ThemeProvider>
  </Provider>
);

reportWebVitals();
